import Utils from 'src/utils';
import { compose } from 'ramda';
function getEventDate(event) {
    return event.StartDateTime.slice(0, 10);
}
function getCreatedEventsMap(newEvents) {
    const eventsForUsers = new Map();
    newEvents?.forEach((event) => {
        const date = getEventDate(event);
        const userEvents = eventsForUsers.get(event.UserId) || {};
        eventsForUsers.set(event.UserId, {
            ...userEvents,
            [date]: userEvents[date] ? [...userEvents[date], event] : [event]
        });
    });
    return eventsForUsers;
}
export function replaceEventsInPlannerState(events, newEvents) {
    const eventsMap = compose(Utils.objects.normalizeList('Id'))(newEvents);
    const eventsForUsers = getCreatedEventsMap(newEvents);
    return events.map((periodEventsSummary) => {
        const createdEventsForUserByDate = eventsForUsers.get(periodEventsSummary.User.UserId);
        if (createdEventsForUserByDate) {
            return {
                ...periodEventsSummary,
                WorkDayEvents: periodEventsSummary.WorkDayEvents?.map((daySummary) => {
                    const date = daySummary.Date.slice(0, 10);
                    if (date in createdEventsForUserByDate) {
                        return ({
                            ...daySummary,
                            Events: !daySummary.Events?.length
                                ? createdEventsForUserByDate[date]
                                : daySummary.Events.map((dayEvent) => {
                                    const event = createdEventsForUserByDate[date].find((newEvent) => newEvent.Id === dayEvent.Id);
                                    if (event) {
                                        return { ...dayEvent, ...event };
                                    }
                                    return dayEvent;
                                })
                        });
                    }
                    return ({
                        ...daySummary,
                        Events: daySummary.Events?.filter((dayEvent) => !eventsMap[dayEvent.Id])
                    });
                })
            };
        }
        return ({
            ...periodEventsSummary,
            WorkDayEvents: periodEventsSummary.WorkDayEvents?.map((daySummary) => ({
                ...daySummary,
                Events: daySummary.Events?.filter((dayEvent) => !eventsMap[dayEvent.Id])
            }))
        });
    });
}
export function removeEventsFromPlannerState(events, deletedIds) {
    const deletedIdsMap = Utils.arrays.arrayToKeyMap(deletedIds);
    return events.map((event) => ({
        ...event,
        WorkDayEvents: event.WorkDayEvents?.map((workDayEvent) => ({
            ...workDayEvent,
            Events: workDayEvent.Events?.filter((dayEvent) => !(dayEvent.Id in deletedIdsMap))
        }))
    }));
}
